// extracted by mini-css-extract-plugin
module.exports = {"container":"Oa-z","copy":"Pa-z","field":"Qa-z","error":"Ra-z","disabled":"Sa-z","termsContainer":"Ta-z","termsHeading":"Ua-z","termsCopy":"Va-z","submit":"Wa-z","srOnly":"Xa-z"};